import { toast } from "react-toastify";
import i18n from "../i18n";

// Backend (PublicMethod::uploadImage) bilan bir xil ro'yxat. Asosiy himoya backend'da —
// bu yerda foydalanuvchi noto'g'ri faylni darhol bilishi uchun.
export const ALLOWED_EXTENSIONS = ["pdf", "docx", "xlsx", "jpg", "jpeg", "png", "gif", "webp", "bmp"];
export const MAX_UPLOAD_BYTES = 20 * 1024 * 1024;
const ACCEPT = ALLOWED_EXTENSIONS.map((e) => "." + e).join(",");

const extOf = (name) => String(name || "").split(".").pop().toLowerCase();

export const checkFile = (file) => {
  if (!ALLOWED_EXTENSIONS.includes(extOf(file.name))) return "upload_type_not_allowed";
  if (file.size > MAX_UPLOAD_BYTES) return "upload_too_large";
  return null;
};

// Sahifadagi barcha fayl maydonlariga accept qo'yish (fayl tanlash oynasida faqat ruxsat etilganlar)
const applyAccept = (root) => {
  root.querySelectorAll?.('input[type="file"]:not([data-upload-guard])').forEach((input) => {
    input.setAttribute("accept", ACCEPT);
    input.setAttribute("data-upload-guard", "1");
  });
};

if (typeof window !== "undefined") {
  applyAccept(document);
  new MutationObserver((mutations) => {
    mutations.forEach((m) => m.addedNodes.forEach((n) => n.nodeType === 1 && applyAccept(n.parentNode || n)));
  }).observe(document.documentElement, { childList: true, subtree: true });

  // window capture fazasi React'dan oldin ishlaydi: noto'g'ri fayl formaga umuman yetib bormaydi
  window.addEventListener(
    "change",
    (e) => {
      const input = e.target;
      if (!(input instanceof HTMLInputElement) || input.type !== "file" || !input.files?.length) return;
      const bad = Array.from(input.files).map(checkFile).find(Boolean);
      if (bad) {
        e.stopImmediatePropagation();
        e.preventDefault();
        input.value = "";
        toast.error(i18n.t(bad));
      }
    },
    true
  );
}
